import * as fromApp from './../../store/app.reducers';

import * as SettingActions from './setting.actions';
import * as ErrorActions from '../../error/store/error.actions';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, mergeMap, switchMap} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {of} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {SubscriptionService} from '../subscription.service';
import {SubscriptionModel} from '../subscription.model';
import {ToastrService} from 'ngx-toastr';

@Injectable()
export class SettingEffects {

  getSubscriptions = createEffect(() => this.actions$
    .pipe(
      ofType(SettingActions.GET_SUBSCRIPTIONS),
      map(
        (data: {type: string, payload: { params: any } }) => {
          return data.payload;
        }
      ),
      switchMap(
        (data: {params: any}) => {

          return this.subscriptionService.getSubscriptions(data.params).pipe(
            mergeMap(
              (response: any) => {

                return [{
                  type: SettingActions.SAVE_SUBSCRIPTIONS,
                  payload: response._embedded.items
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  cancelSubscriptions = createEffect(() => this.actions$
    .pipe(
      ofType(SettingActions.CANCEL_SUBSCRIPTION),
      map(
        (data: {type: string, payload: { id: number } }) => {
          return data.payload;
        }
      ),
      switchMap(
        (data: {id: number}) => {

          return this.subscriptionService.deleteSubscription(data.id).pipe(
            mergeMap(
              (response: any) => {
                this.notifierService.success('Subscription has been cancelled');
                return [{
                  type: SettingActions.UPDATE_LOCAL_SUBSCRIPTION,
                  payload: {id: data.id, keyName: 'status', value: SubscriptionModel.STATUS_CANCELLED}
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  getSubscriptionItems = createEffect(() => this.actions$
    .pipe(
      ofType(SettingActions.GET_SUBSCRIPTION_ITEMS),
      map(
        (data: {type: string, payload: { id: number } }) => {
          return data.payload;
        }
      ),
      switchMap(
        (data: {id: number}) => {

          return this.subscriptionService.getSubscriptionItems(data.id).pipe(
            mergeMap(
              (response: any) => {

                return [{
                  type: SettingActions.SAVE_SUBSCRIPTION_ITEMS,
                  payload: response
                }];
              }
            ),
            catchError(
              (err: HttpErrorResponse) => {
                return of({
                  type: ErrorActions.SET_HTTP_ERROR,
                  payload: err
                });
              }
            )
          );
        }
      )
    ), {dispatch: true}
  );

  constructor(
    private actions$: Actions,
    private subscriptionService: SubscriptionService,
    private router: Router,
    private notifierService: ToastrService,
    private store: Store<fromApp.AppState>,
    private route: ActivatedRoute,
  ) {}
}
